import { render, staticRenderFns } from "./ProductFlashConfig.vue?vue&type=template&id=97bd524a&scoped=true&"
import script from "./ProductFlashConfig.vue?vue&type=script&lang=js&"
export * from "./ProductFlashConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd524a",
  null
  
)

export default component.exports